module.exports = __webpack_public_path__ + "static/media/cell_topbox_default.67391d9c.jpg";